import { Api } from '@automapa/svelte-automapa-template';
import { z } from 'zod';

export const GuidePageSchema = z.object({
    slug: z.string(),
    title: z.string(),
    url: z.string(),
    html: z.string(),
});

export const GuideChapterSchema = z.object({
    key: z.string(),
    title: z.string(),
    url: z.string(),
    pages: z.array(GuidePageSchema),
});

export const GuideDocumentationSchema = z.object({
    chapters: z.array(GuideChapterSchema),
});

export const GuideResetCacheSchema = z.object({
    cleared: z.boolean(),
});

export type GuidePageType = z.infer<typeof GuidePageSchema>;
export type GuideChapterType = z.infer<typeof GuideChapterSchema>;
export type GuideDocumentationType = z.infer<typeof GuideDocumentationSchema>;
export type GuideResetCacheType = z.infer<typeof GuideResetCacheSchema>;

export class GuideApi {
    public static async getDocumentation(api: Api): Promise<GuideDocumentationType> {
        return api.getData<Record<string, never>, GuideDocumentationType>(
            'post',
            '/guide/get_documentation',
            {},
            z.object({}),
            GuideDocumentationSchema
        );
    }

    /** Clears the server-side guide cache so the next getDocumentation() re-downloads from BookStack. */
    public static async resetCache(api: Api): Promise<GuideResetCacheType> {
        return api.getData<Record<string, never>, GuideResetCacheType>(
            'post',
            '/guide/reset_cache',
            {},
            z.object({}),
            GuideResetCacheSchema
        );
    }
}
